const base = "cui-anchor-xoc6";
const classes = {
  base
};
export {
  base,
  classes as default
};
